import gql from 'graphql-tag';

import { CALENDAR_EVENT_FRAGMENT } from './fragments/calendarEvent.fragment';

export const LIST_OF_CALENDAR_EVENTS = gql`
  query ListOfCalendarEvents($input: CalendarEventsInput!) {
    dealActivity {
      result: calendarEvents(input: $input) {
        error
        success
        list {
          ...CalendarEventFields
        }
      }
    }
  }
  ${CALENDAR_EVENT_FRAGMENT}
`;
